import { Document } from "@carbon/icons-react";
import { ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";

import EditableItemListItem from "../../../../../components/editableItemList/EditableItemListItem";
import { IDocument } from "../../../../../models/document";
import { fileSizeInMb } from "../../../../../utils/helper";

interface DocumentItemListItemProps {
  documentItem: IDocument;
  onEdit: (item: IDocument) => void;
  onDelete: (id: string) => void;
}

const DocumentItemListItem = (props: DocumentItemListItemProps) => {
  const { t } = useTranslation();
  const { documentItem, onEdit, onDelete } = props;

  const fileSizeInMB = documentItem.file && fileSizeInMb(documentItem.file);

  return (
    <EditableItemListItem
      item={documentItem}
      itemId={documentItem.id}
      onEdit={onEdit}
      onDelete={onDelete}
      icon={<Document className="list-item-icon" size={24} />}
    >
      <ListItemText
        sx={{ wordBreak: "break-all" }}
        primary={`${documentItem.name} - ${t(documentItem.documentType || "")}`}
        secondary={
          documentItem.file && `${documentItem.file?.name} - ${fileSizeInMB}`
        }
      />
    </EditableItemListItem>
  );
};

export default DocumentItemListItem;
